import { render, staticRenderFns } from "./document-edit-modal.vue?vue&type=template&id=c4b69d48"
import script from "./document-edit-modal.vue?vue&type=script&lang=js"
export * from "./document-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports